import {
  MutationUpdatePluginArgs,
  MutationCreatePluginListingArgs,
  MutationUpdatePluginListingArgs,
  MutationCreatePluginArgs,
  MutationDeletePluginArgs,
} from '@trello/graphql/generated';
import {
  QueryInfo,
  prepareDataForApolloCache,
} from '../prepareDataForApolloCache';
import { token } from '@trello/session-cookie';
import { clientVersion } from '@trello/config';

export const updatePlugin = async (
  obj: object,
  args: MutationUpdatePluginArgs,
  context: object,
  info: QueryInfo,
) => {
  if (!args.fields) {
    throw new Error('Expected fields argument is missing.');
  }

  const response = await fetch(`/1/plugin/${args.pluginId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    body: JSON.stringify({
      ...args.fields,
      token,
    }),
  });

  const plugin = await response.json();

  return prepareDataForApolloCache(plugin, info);
};

export const updatePluginListing = async (
  obj: object,
  args: MutationUpdatePluginListingArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(
    `/1/plugin/${args.pluginId}/listings/${args.pluginListingId}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Trello-Client-Version': clientVersion,
      },
      body: JSON.stringify({
        ...args,
        token,
      }),
    },
  );

  const listing = await response.json();

  return prepareDataForApolloCache(listing, info);
};

export const createPluginListing = async (
  obj: object,
  args: MutationCreatePluginListingArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/plugin/${args.pluginId}/listings`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    body: JSON.stringify({
      ...args,
      token,
    }),
  });

  const listing = await response.json();

  return prepareDataForApolloCache(listing, info);
};

export const createPlugin = async (
  obj: object,
  args: MutationCreatePluginArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/plugin`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    body: JSON.stringify({
      idAgreement: args.agreementId,
      idOrganizationOwner: args.organizationId,
      iframeConnectorUrl: args.iframeConnectorUrl,
      listings: args.listings,
      author: args.author || '',
      token,
    }),
  });

  const plugin = await response.json();

  return prepareDataForApolloCache(plugin, info);
};

export const deletePlugin = async (
  obj: object,
  args: MutationDeletePluginArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/plugins/${args.pluginId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    body: JSON.stringify({
      token,
    }),
  });

  await response.json();

  return prepareDataForApolloCache({ success: true }, info);
};
